import type { Site } from '../Site';

export const PricePandaID: Site = {
  id: 'pricepandaid',
  logo: '',
  label: 'PricePanda ID',
  analyticsName: 'pricepandaid',
  hostname: 'pricepanda.co.id',
  platform: 'responsive',
  selector: 'main a',
};
